import { render } from "./avtor.vue?vue&type=template&id=b2fe141c&scoped=true"
import script from "./avtor.vue?vue&type=script&lang=js"
export * from "./avtor.vue?vue&type=script&lang=js"

import "./avtor.vue?vue&type=style&index=0&id=b2fe141c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fe141c"]])

export default __exports__